import React from 'react';
import PainPointCards from '../inputs/PainPointCards';
import { useAnalytics } from '../../../hooks/useAnalytics';

const PainPointsStep = ({
  data = {},
  onChange,
  disabled = false
}) => {
  const { painPoints = [] } = data;
  const analytics = useAnalytics();

  const handlePainPointsChange = (newPainPoints) => {
    onChange({ ...data, painPoints: newPainPoints });

    // Track pain point selection
    if (newPainPoints.length > 0) {
      analytics.trackPainPointSelect(newPainPoints, 4);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 tabIndex={-1} className="survey-heading text-2xl font-['Space_Grotesk'] font-medium mb-2 text-white">
          Which of these problems have you experienced?
        </h3>
        <p className="text-sm text-white/60">
          Select all that apply
        </p>
      </div>

      <PainPointCards
        value={painPoints}
        onChange={handlePainPointsChange}
        disabled={disabled}
      />
    </div>
  );
};

export default PainPointsStep;
